import { api } from "../configs/axiosConfig"

export const MessageAPI = {
  sendMessage: async function (message, signal = false) {
    const conversationId = window.sessionStorage.getItem('conversationId');
    const password = window.localStorage.getItem('password');
    const country = window.localStorage.getItem('country');
    const storeId = window.localStorage.getItem('storeId');
    
    if (!conversationId || !password || !country || !storeId) {
      window.dispatchEvent(new Event("logout"));
    }

    const response = await api.request({
      method: "POST",
      url: "/integration/api/message",
      auth: {
        username: "licowebapp",
        password: password
      },
      data: {
        conversationId: conversationId,
        content: message,
        user: {
          country: country,
          storeId: storeId
        }
      },
      signal: signal ? signal : undefined
    })

    return response.data
  },
}